// extracted by mini-css-extract-plugin
export default {"arrows":"Arrows_arrows__g9h0L","arrow":"Arrows_arrow__chk5e"};